import { GoogleMap, InfoWindow, withGoogleMap, withScriptjs } from "react-google-maps"
import * as React from 'react';
import { compose, withProps } from "recompose";
import Marker from 'react-google-maps/lib/components/Marker';
import { Dot } from './routeSelector';
import { DriverVisitHistory } from '../api/model';
// import InfoBox from 'react-google-maps/lib/components/addons/InfoBox';
// import { formatDistance } from 'date-fns';
// import Button from '@material-ui/core/Button';
// import { Link } from "react-router-dom";
import LocalIcon from '../assets/imgs/cheese.png';
import { ConfigData } from "../config";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

// const getColor = (data: DriverVisitHistory): string => {
//     if (data.raceId) {
//         switch (data.raceState) {
//             case RaceState.IN_PROGRESS:
//                 return 'yellow';
//             case RaceState.DELIVERED:
//                 return 'green';
//             case RaceState.ASSIGNED:
//                 return 'red'
//         }
//     }

//     return 'purple';
// };

// interface MarkerOfDriverWithInfoProps {
//     data: DriverVisitHistory[];
// }
// const MarkerOfDriverWithInfo: React.SFC<any> = (props: any) => {
//     const pathCoordinates = props.data.map((driverHistory: DriverVisitHistory) => {
//         return { lat: driverHistory.lat, lng: driverHistory.lng };
//     });
//     return <Polyline
//         path={pathCoordinates}
//         options={{
//             strokeColor: "#ff2527",
//             strokeOpacity: 0.75,
//             strokeWeight: 2,
//             icons: [
//                 {
//                     offset: "0",
//                     repeat: "20px"
//                 }
//             ]
//         }}
//     />
// };

interface MapProps {

    zoom: number;
    center: Dot;
    data: DriverVisitHistory[];
    predefinedFrom: boolean;

    handleOnClick(e: google.maps.MouseEvent | google.maps.IconMouseEvent): void;

}

class MapOfDrivers extends React.Component<MapProps, { open: { [K: number]: boolean }, selectedMarker: DriverVisitHistory | null }> {

    constructor(props: MapProps) {
        super(props);
        this.state = {
            open: {},
            selectedMarker: null
        }
        this.handleMarkerClick= this.handleMarkerClick.bind(this);
    }

    toggle = (info: DriverVisitHistory) => {
        this.setState({
            open: {
                [info.id]: !this.state.open[info.id]
            }
        })
    };

    handleMarkerClick(driverHistory: DriverVisitHistory) {
        console.info("driverHistory: ", driverHistory);
        this.setState({ selectedMarker: driverHistory });
    };

    handleInfoWindowCloseClick = () => {
        this.setState({ selectedMarker: null });
    };


    render() {
        console.info("Mapa: ", this.props);
        const { center, zoom, handleOnClick } = this.props;
        return <div>
            <GoogleMap defaultZoom={zoom} center={center} onClick={handleOnClick}>
                {this.props.predefinedFrom && <Marker
                    position={this.props.center}
                    labelContent="Meet & Cheese"
                    icon={{
                        url: LocalIcon,
                        scale: 3
                    }}
                />}
                {/* <MarkerOfDriverWithInfo data={this.props.data} /> */}

                {this.props.data.map((driverHistory: DriverVisitHistory, index: number) => (
                    <Marker
                        key={index}
                        position={{ lat: driverHistory.lat, lng: driverHistory.lng }}
                        onClick={(e) => this.handleMarkerClick(driverHistory)}
                    />
                ))}

                {this.state.selectedMarker && (
                    <InfoWindow
                        position={{ lat: this.state.selectedMarker.lat, lng: this.state.selectedMarker.lng }}
                        onCloseClick={this.handleInfoWindowCloseClick}
                    >
                        <div style={{ padding: 5, width: 300 }}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Fecha:</td>
                                        <td>{this.state.selectedMarker.visitDate}</td>
                                    </tr>
                                    {this.state.selectedMarker.client && <tr>
                                        <td>Cliente:</td>
                                        <td>{this.state.selectedMarker.client.user.name}</td>
                                    </tr>}
                                    {this.state.selectedMarker.visitReason &&<tr>
                                        <td>Motivo de visita:</td>
                                        <td>{this.state.selectedMarker.visitReason.description}</td>
                                    </tr>}
                                    <tr>
                                        <td>Observaciones:</td>
                                        <td>{this.state.selectedMarker.obs}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <Link to={"/visit/" + this.state.selectedMarker.id}>
                                <Button color="primary">{"Ver mas detalles"}</Button>
                            </Link>
                        </div>
                    </InfoWindow>
                )}
            </GoogleMap>
        </div>
    }
}

const EnhancedMap = compose<MapProps, MapProps>(
    withProps({
        containerElement: <div style={{ height: '400px' }} />,
        mapElement: <div style={{ height: '400px' }} />,
    }),
    withGoogleMap
)(MapOfDrivers);

interface DriverHistoryVisitProps {
    data: DriverVisitHistory[],
    config: ConfigData;
}

const DriverHistoryVisitComponent: React.SFC<DriverHistoryVisitProps> = (props: DriverHistoryVisitProps) => {

    return (
        <EnhancedMap
            center={props.config.maps.startingLocation}
            predefinedFrom={props.config.races.predefinedFrom}
            zoom={props.config.maps.startingLocation.zoom}
            data={props.data}
            handleOnClick={(dat) => {
                console.log(dat)
            }}
        >
        </EnhancedMap>
    );

};


export default compose<any, DriverHistoryVisitProps>(withProps((props: DriverHistoryVisitProps) => {
    return {
        googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
        loadingElement: <div style={{ height: '400px' }} />,
    }
}), withScriptjs)(DriverHistoryVisitComponent);



// WEBPACK FOOTER //
// ./src/components/DriverHistoryVisit.tsx